import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

import css from './ProductGroupComponent.module.css';
import {ButtonDelete, ButtonUpdate, ModalForDelete} from "../../../ui";
import {productGroupService} from "../../../services/settings-services";
import {productGroupsActions} from "../../../store/slices/settings-slices";
import {
    ProductGroupsUpdateProductGroupModal
} from "../settingSectionModals/ProductGroupsUpdateProductGroupModal/ProductGroupsUpdateProductGroupModal";


const ProductGroupComponent = (props) => {
    const dispatch = useDispatch();
    const {i18n} = useTranslation();
    const [isOpenUpdate, setIsOpenUpdate] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    const {productGroups: {id, name}} = props;

    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name["en"];

    const handleDeleteClick = async () => {
        try {
            await productGroupService.deleteById(id);
            dispatch(productGroupsActions.changeTrigger());
            toast.success('group is deleting!');
        } catch (error) {
            console.error("Error deleting group:", error);
        }
    };

    const handleUpdateClick = () => {
        setIsOpenUpdate(true);
    };


    return (
        <section className={css.wrap}>
            <section className={css.title}>{displayName}</section>

            <section className={css.blockButton}>
                <ButtonUpdate onClick={handleUpdateClick}/>
                <ButtonDelete onClick={() => setIsOpenDeleteModal(true)}/>
            </section>

            {isOpenUpdate && <ProductGroupsUpdateProductGroupModal
                setIsOpenUpdate={setIsOpenUpdate}
                productGroup={props.productGroups}
            />}

            {isOpenDeleteModal && <ModalForDelete
                handleDeleteClick={handleDeleteClick}
                setIsOpenDeleteModal={setIsOpenDeleteModal}
                name={'category'}
            />}
        </section>
    );
};

export default React.memo(ProductGroupComponent);